module.exports = __webpack_public_path__ + "media/icons/user-2f8d533cefda1626ac4cd95930cb052a.svg";